import { verifyPasswordCode } from '@/features/user/api/password-reset.service'
import {
  AuthenticationPageContainer,
  ResetPasswordForm
} from '@/features/user/components'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { UnauthenticatedPage } from '../components/UnauthenticatedPage/UnauthenticatedPage'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordComponent,
  validateSearch: z.object({
    oobCode: z.string()
  }),
  beforeLoad: async ({ search: { oobCode } }) => {
    const codeValid = await verifyPasswordCode({ oobCode })
    if (!codeValid) {
      throw redirect({
        to: '/reset-password-expired'
      })
    }
  }
})

function ResetPasswordComponent() {
  const { t } = useTranslation('_routes')
  const { oobCode } = Route.useSearch()

  return (
    <AuthenticationPageContainer
      advertisingChip={t('routes.reset-password.main.advertising.chip')}
      advertisingTitle={t('routes.reset-password.main.advertising.title')}
      advertisingSubtitle={t('routes.reset-password.main.advertising.subTitle')}
    >
      <UnauthenticatedPage>
        <ResetPasswordForm isLoading={false} oobCode={oobCode} />
      </UnauthenticatedPage>
    </AuthenticationPageContainer>
  )
}
